module.exports = __webpack_public_path__ + "img/ay.bd81ebab.jpg";